import styles from '@/components/elements/BrandedBox/BrandedBox.module.scss'

const BrandedBox = ({ className, children }: any) => {
  return <div className={`${styles.root} ${className}`}>{children}</div>
}

export default BrandedBox
